export default "__VITE_ASSET__y260LnXS__"